
import { useState } from 'react';
import { motion } from 'framer-motion';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <motion.nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.6 }}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-[rgba(0,34,0,0.9)] shadow-lg backdrop-blur-sm'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 lg:px-8 h-[70px] lg:h-[90px] flex items-center justify-between">
          <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => scrollToSection('hero')}
          >
            <img
              src="https://static.readdy.ai/image/f7081275c8c5ad77b7068ab2b9330b46/2a07c29672384106c5a8c41b0fb0a062.png"
              alt="Vitta Prime Grass"
              className="h-[60px] lg:h-[90px] w-auto object-contain"
              translate="no"
            />
          </div>

          {/* Mobile Hamburger Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer text-white"
            aria-label="Menu"
            type="button"
          >
            <span
              className={`block w-6 h-0.5 transition-all duration-300 bg-white ${
                mobileMenuOpen ? 'rotate-45 translate-y-2' : ''
              }`}
            ></span>
            <span
              className={`block w-6 h-0.5 transition-all duration-300 bg-white ${
                mobileMenuOpen ? 'opacity-0' : ''
              }`}
            ></span>
            <span
              className={`block w-6 h-0.5 transition-all duration-300 bg-white ${
                mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''
              }`}
            ></span>
          </button>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-10">
            <button
              onClick={() => scrollToSection('sobre')}
              className="font-montserrat text-sm uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#C5A059]"
              translate="no"
            >
              A Empresa
            </button>
            <button
              onClick={() => scrollToSection('limonta')}
              className="font-montserrat text-sm uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#C5A059]"
            >
              <span translate="no" className="notranslate">
                Tecnologia Limonta
              </span>
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="font-montserrat text-sm uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#C5A059]"
            >
              Nossos Projetos
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="font-montserrat text-sm uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#C5A059]"
            >
              Contato
            </button>
            <a
              href="https://wa.me/5518996901341"
              target="_blank"
              rel="noopener noreferrer"
              className="font-montserrat text-sm font-semibold tracking-wide transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2 text-[#C5A059] hover:text-white"
            >
              <i className="ri-whatsapp-line"></i>
              (18) 99690-1341
            </a>
          </div>
        </div>

        <div
          className={`h-[1px] bg-[#C5A059] opacity-30 transition-opacity ${
            scrolled ? 'opacity-100' : 'opacity-0'
          }`}
        />
      </motion.nav>

      {/* Mobile Menu - Completely separate from motion.nav, pure HTML */}
      {mobileMenuOpen && (
        <nav
          className="fixed lg:hidden"
          style={{
            top: 70,
            left: 0,
            right: 0,
            zIndex: 9999,
            backgroundColor: '#002200',
          }}
        >
          <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            <li>
              <a
                href="#sobre"
                className="font-montserrat text-sm uppercase tracking-wide text-white no-underline"
                translate="no"
                style={{
                  display: 'block',
                  padding: 16,
                  textDecoration: 'none',
                  color: '#ffffff',
                }}
                onClick={() => setMobileMenuOpen(false)}
              >
                A Empresa
              </a>
            </li>
            <li>
              <a
                href="#limonta"
                className="font-montserrat text-sm uppercase tracking-wide text-white no-underline"
                style={{
                  display: 'block',
                  padding: 16,
                  textDecoration: 'none',
                  color: '#ffffff',
                }}
                onClick={() => setMobileMenuOpen(false)}
              >
                <span translate="no" className="notranslate">
                  Tecnologia Limonta
                </span>
              </a>
            </li>
            <li>
              <a
                href="#servicos"
                className="font-montserrat text-sm uppercase tracking-wide text-white no-underline"
                style={{
                  display: 'block',
                  padding: 16,
                  textDecoration: 'none',
                  color: '#ffffff',
                }}
                onClick={() => setMobileMenuOpen(false)}
              >
                Nossos Projetos
              </a>
            </li>
            <li>
              <a
                href="#contato"
                className="font-montserrat text-sm uppercase tracking-wide text-white no-underline"
                style={{
                  display: 'block',
                  padding: 16,
                  textDecoration: 'none',
                  color: '#ffffff',
                }}
                onClick={() => setMobileMenuOpen(false)}
              >
                Contato
              </a>
            </li>
            <li>
              <a
                href="https://wa.me/5518996901341"
                target="_blank"
                rel="noopener noreferrer"
                className="font-montserrat text-sm font-semibold tracking-wide no-underline"
                style={{
                  display: 'block',
                  padding: 16,
                  textDecoration: 'none',
                  color: '#C5A059',
                }}
                onClick={() => setMobileMenuOpen(false)}
              >
                <i className="ri-whatsapp-line" style={{ marginRight: 8 }}></i>
                (18) 99690-1341
              </a>
            </li>
          </ul>
        </nav>
      )}
    </>
  );
}
